import { apiSlice } from '@/features/api/apiSlice';

export type Usage = {
  plan: string;
  sends: number;
  templates: number;
  apiCalls: number;
  limits: {
    sends: number | 'unlimited';
    templates: number | 'unlimited';
  };
};

export const usageApi = apiSlice.injectEndpoints({
  endpoints: (b) => ({
    getUsage: b.query<Usage, void>({
      query: () => '/usage',
      providesTags: ['Send'],
    }),
  }),
});

export const { useGetUsageQuery } = usageApi;
